
























































































































import { Component, Vue } from "vue-property-decorator";
import {Company, Currency} from "@/interfaces";
import {readCompanies, readHasAdminAccess, readOneCompany} from "@/store/main/getters";
import {dispatchGetCompanies, dispatchGetCompany} from "@/store/main/actions";
import {readCurrencies} from "@/store/wallet/getters";
import {dispatchGetCurrencies} from "@/store/wallet/actions";


@Component
export default class ViewCompany extends Vue {

  public loading = true;


  get companies() {
    return  readCompanies(this.$store);
  }

  get company(){
    return readOneCompany(this.$store)( +this.$router.currentRoute.params.id );
  }

  public rotates: number[] = [];

  public async mounted() {

    await dispatchGetCurrencies(this.$store);


    const id = +this.$router.currentRoute.params.id;
    const own = !readHasAdminAccess(this.$store) // if admin set own to false


    if (this.companies.length == 0){
      await Promise.allSettled([
        dispatchGetCompany(this.$store,{ id:id,own:own}),
      ]);
    }

    this.loading = false;

    let deg = 270;
    this.company?.contracts.map(contract =>{
      this.rotates.push(deg)
      deg = deg + (contract.share * 3.6);

    })

  }

  public getHashrate(hashrate: number, currency_id: number) {
    let unit = "MH";
    let fix_number = 2;
    let power_number = 6;
    if(this.getCurrencyName(currency_id) == "XCC" ||  this.getCurrencyName(currency_id) == "XCH"){
      unit = "TB";
      fix_number = 5;
      power_number = 12;
    }
    return (hashrate / 10 ** power_number).toFixed(fix_number) +unit;
  }

  public getCurrencyName(currency_id: number) {
    return readCurrencies(this.$store).find(
        (currency: Currency) => currency.id === currency_id
    )!.name;
  }

  public hashText(currency_id){
    const currency = this.getCurrencyName(currency_id)
    if (currency == "XCC" || currency == "XCC")
      return "حجم"
    else
      return "نرخ هش"
  }


  public getColor(index){
    const mod  = index % 10;
    switch (mod) {
      case 0:
        return "#F44336";
      case 1:
        return "#E91E63";
      case 2:
        return "#2196F3";
      case 3:
        return "#FF9800";
      case 4:
        return "#9C27B0";
      case 5:
        return "#4CAF50";
      case 6:
        return "#3F51B5";
      case 7:
        return "#607D8B";
      case 8:
        return "#009688";
      case 9:
        return "#673AB7";

    }
  }

}
